import { fork } from "redux-saga/effects";
import { appSaga } from "../app/saga";
import { homeSaga } from "../page/Home/saga";

export function* rootSaga() {
  yield fork(appSaga);
  yield fork(homeSaga);
}
